<template>
    <app-page>
	    <content-container id="user-list" class="p-1">
		    <card title="Users">

				 <toolbar class="p-1">
				    <toolbar-group>
					    <toolbar-button @click="addUser">
						    <icon src="person_add" title="Add user" />
					    </toolbar-button>
				    </toolbar-group>
			    </toolbar>

				<kendo-datasource
					ref="gridDataSource"
					:page-size="gridDataSource.pageSize"
					:schema="gridDataSource.schema"
					:server-paging="true"
					:server-sorting="true"
					:server-filtering="true"
					:transport-read="gridDataSource.transport.read"
					:transport-parameter-map="gridDataSource.transport.parameterMap"
				/>
				<kendo-grid
                    ref="grid"
                    :column-resize-handle-width="8"
                    :column-menu="false"
                    :data-source-ref="'gridDataSource'"
                    :filterable="grid.filterable"
                    :groupable="grid.groupable"
                    :pageable="grid.pageable"
                    :resizable="false"
					:selectable="'row'"
                    :sortable="true"
					@change="onGridChange"
                >
                    <kendo-grid-column 
						field="userName" 
						title="User name" 
						width="150px" 
                        template="<span class='text-link'>#=userName#</span>"
						:filterable-cell-show-operators="false"
					/>
                    <kendo-grid-column 
						field="firstName" 
						title="First name" 
						width="130px" 
						:filterable-cell-show-operators="false" 
					/>
					<kendo-grid-column 
						field="lastName" 
						title="Last name" 
						width="130px" 
						:filterable-cell-show-operators="false" 
					/>
                    <kendo-grid-column 
						field="emailAddress" 
						title="Email"
                        width="240px"
						:filterable-cell-show-operators="false" 
					/>
					<kendo-grid-column
						field="lastLoginOn"
						title="Last Logged In"
						width="150px"
						:filterable-cell-show-operators="false"	
						template="#= (lastLoginOn == null) ? '' : kendo.toString(lastLoginOn, 'MMMM dd, yyyy hh:mm tt') #"
					/>
                </kendo-grid>

		    </card>

			<add-unregistered-user-modal
			    ref="addUnregisteredUserModal"
                @add="onUserAdded"
		    />

	    </content-container>
    </app-page>
</template>


<script>
	import _ from 'lodash';
	import { AsyncMixin } from 'pdk/mixins';
    import { users } from '@/services';
    import { KendoGridMixin } from '@/mixins';
	import { AddUnregisteredUserModal } from './modals';


	export default {
		name: 'user-list',
		components: {
			AddUnregisteredUserModal
		},
		mixins: [AsyncMixin, KendoGridMixin],
		data() {
			return {
				grid: {
                    filterable: {
                        mode: 'row',
						extra: false
                    },
                    groupable: {
                        enabled: false,
                        showFooter: false
					},
					pageable: {
                        alwaysVisible: true,
                        refresh: true
					}
                },
                gridDataSource: users.getUsers_KendoDataSource()
			};
		},
		activated() {
			this.$refs.gridDataSource.kendoDataSource.read();
		},
		methods: {
			editUser(user) {
				this.$router.push({
					name: 'manage-user',
					params: {
						globalUserId: user.globalUserID
					}
				});
			},
			addUser() {
				this.$refs.addUnregisteredUserModal.open();
			},
            refresh() {
                this.getKendoGridHelper('grid').refresh();
            },

            // Event handlers
            onGridChange(e) {
				var rows = e.sender.select();
				var dataItem = e.sender.dataItem(e.sender.select());				
				this.editUser(dataItem);
			},
            onUserAdded(user) {
                this.refresh();
            }
		}
	};
</script>
